<template>
  <div class="background-video-slider carousel slide" data-ride="carousel" id="backgroundVideoSliderVersionTwo" role="region" :data-brand="getBrand">
    <div class="carousel-inner" role="listbox">
      <div class="item sokal-component-slide slide-0 slide-id-6932 video-slide active slow-load slide-processed video-can-play">
        <div class="component-slide-content">
          <video v-if="images.videoLink.length > 0" class="slide-background-video" loop="true" muted="true" playsinline="true" preload="metadata" autoplay="true">
            <source :src="images.videoLink" type="video/mp4">
          </video>
          <div class="slide-background-overlay"></div>
          <div class="slide-content-layer sokal-content-fade-in">
            <div class="slide-text-content">
              <div class="offer-text-template-4">
                <p class="sokal-component-copy">Welcome to</p>
                <h2 class="sokal-component-heading">Hometown {{ formattedBrand }}</h2>
                <a class="vehicles-in-stock sokal-flex sokal-gap">
                  <span>745 vehicles in stock</span>
                  <svg class="sokal-utility-icon" fill="none" height="14" viewBox="0 0 16 14" width="16" xmlns="http://www.w3.org/2000/svg"><path d="M1 7H15M15 7L9 13M15 7L9 1" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"></path></svg>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="item sokal-component-slide slide-1 slide-id-6931 bg-image-slide">
        <div class="component-slide-content">
          <div class="slide-background">
            <img class="slide-background-image" :src="images.lifestyleImages.suvImage" role="presentation">
          </div>
          <div class="slide-background-overlay"></div>
          <div class="slide-content-layer sokal-content-fade-in">
            <div class="slide-text-content">
              <div class="offer-text-template-3">
                <h3 class="sokal-component-subheading">Explore</h3>
                <h2 class="sokal-component-heading">Shop New {{ getBrand === 'Default' ? '2026' : formattedBrand }} SUVs</h2>
              </div>
            </div>
            <div class="slide-buttons" data-first-btn-present="true">
              <a class="vehicles-in-stock sokal-flex sokal-gap">
                <span>View Inventory</span>
                <svg class="sokal-utility-icon" fill="none" height="14" viewBox="0 0 16 14" width="16" xmlns="http://www.w3.org/2000/svg"><path d="M1 7H15M15 7L9 13M15 7L9 1" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"></path></svg>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="item sokal-component-slide slide-2 slide-id-6936 bg-image-slide">
        <div class="component-slide-content">
          <div class="slide-background">
            <img class="slide-background-image" :src="images.lifestyleImages.sedanImage" role="presentation">
          </div>
          <div class="slide-background-overlay"></div>
          <div class="slide-content-layer sokal-content-fade-in">
            <div class="slide-text-content">
              <div class="offer-text-template-3">
                <h3 class="sokal-component-subheading">Explore</h3>
                <h2 class="sokal-component-heading">Shop New {{ getBrand === 'Default' ? '2026' : formattedBrand }} Sedans</h2>
              </div>
            </div>
            <div class="slide-buttons" data-first-btn-present="true">
              <a class="vehicles-in-stock sokal-flex sokal-gap">
                  <span>Shop Inventory</span>
                  <svg class="sokal-utility-icon" fill="none" height="14" viewBox="0 0 16 14" width="16" xmlns="http://www.w3.org/2000/svg"><path d="M1 7H15M15 7L9 13M15 7L9 1" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"></path></svg>
                </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ol class="carousel-indicators">
      <li class="sokal-slide-indicator active" data-slide-to="0" data-target="#backgroundVideoSliderVersionTwo"></li>
      <li class="sokal-slide-indicator" data-slide-to="1" data-target="#backgroundVideoSliderVersionTwo"></li>
      <li class="sokal-slide-indicator" data-slide-to="2" data-target="#backgroundVideoSliderVersionTwo"></li>
    </ol>
  </div>
</template>

<script>
import "../../static/bootstrap-3.3.7-dist/js/bootstrap.min.js";
import "../assets/styles/sokal-utility-classes.scss";

export default {
  props: ['images'],
  data() {
    return {
      brand: this.$store.state.chosenBrand
    }
  },
  computed: {
    getBrand () {
      if (this.brand.toLowerCase() === 'none') {
        return 'Default';
      } else if (this.brand.toLowerCase() === 'cjdr') {
        return this.brand.toLowerCase();
      } else {
        return this.brand.substr(0,1).toUpperCase() + this.brand.substr(1);
      }
    },
    formattedBrand() {
      const uppercaseBrands = ['cjdr'];

      if (uppercaseBrands.includes(this.getBrand.toLowerCase())) {
        return this.getBrand.toUpperCase();
      }

      return this.getBrand;
    }
  }, 

  mounted () {
    let firstItem = $('.background-video-slider .video-slide');
    firstItem.animate({background: 'linear-gradient(to top, #111111 1%, transparent 40%);'}, "1000");
    setTimeout(function(){
      firstItem.removeClass('slow-load');
    }, 1000);
    this.initSwipe();    
  }, 

  methods: {
    initSwipe() {
      const $ = window.jQuery
      if (!$ || !$.fn.swipe) return

      const $carousel = $('#backgroundVideoSliderVersionTwo')
      if (!$carousel.length) return

      $carousel.swipe({
        swipeLeft() {
          $(this).carousel('next')
        },
        swipeRight() {
          $(this).carousel('prev')
        },
        threshold: 50
      })
    }
  },

  beforeUnmount() {
    const $ = window.jQuery
    if (!$) return

    $('#backgroundVideoSliderVersionTwo').off()
  }
};
</script>

<style
  scoped
  src="../../static/bootstrap-3.3.7-dist/css/bootstrap.min.css"
></style>

<style scoped>
  .background-video-slider {
    --carousel-controls-color: #ffffff;
    --slide-overlay-background-color: #111111;
  }

  #preview:has(#backgroundVideoSliderVersionTwo) {
    margin-left: -9px;
    margin-right: -9px;
  }

  .background-video-slider {
    font-size: 16px;
  }
  .background-video-slider .item {
    width: 100%;
  }
  .background-video-slider button.navigate-slides {
    position: absolute;
    bottom: 10px;
    left: 50%;
  }
  .background-video-slider button.prev-slide {
    left: calc(50% - 15px);
    transform: translateX(calc(-50% - 15px));
  }
  .background-video-slider button.next-slide {
    left: calc(50% + 15px);
    transform: translateX(calc(-50% + 15px));
  }
  .background-video-slider button.navigate-slides {
    width: 45px;
    padding: 0;
    background-color: transparent;
    border: none;
    color: #ffffff;
    color: var(--carousel-controls-color, #ffffff);
  }
  .background-video-slider button.navigate-slides svg {
    -moz-transition: all 0.3s ease;
    -webkit-transition: all 0.3s ease;
    transition: all 0.3s ease;
  }
  .background-video-slider button.navigate-slides:hover svg, 
  .background-video-slider button.navigate-slides:focus svg {
    transform: scale(0.95);
  }
  .background-video-slider .carousel-indicators {
    z-index: auto;
    left: 0;
    bottom: 10%;
    padding-left: 25px;
    margin-left: 0;
    width: fit-content;
  }
  .background-video-slider .carousel-indicators li, 
  .background-video-slider .carousel-indicators .active {
    margin: 0 5px;
  }
  .background-video-slider .carousel-indicators li {
    width: 10px;
    -moz-transition: all 0.3s ease;
    -webkit-transition: all 0.3s ease;
    transition: all 0.3s ease;
    background-color: rgba(255, 255, 255, 0.25);
    border: none;
  }
  .background-video-slider .carousel-indicators .active {
    width: 30px;
    height: 10px;
    background-color: #ffffff;
  }
  .background-video-slider .component-slide-content {
    position: relative;
    min-height: 400px;
    height: 40vh;
    overflow: hidden;
  }
  .background-video-slider .component-slide-content > video {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  .background-video-slider .slide-background {
    width: 100%;
    height: 100%;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
  }
  .background-video-slider[data-brand="Infiniti"] .slide-1 .slide-background .slide-background-image {
    object-position: bottom;
  }
  .background-video-slider .slide-background-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
  }
  .background-video-slider .slide-background-overlay, 
  .background-video-slider .slide-content-layer {
    position: absolute;
  }
  .background-video-slider .slide-background-overlay {
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    -moz-transition: background 1s ease-in-out;
    -webkit-transition: background 1s ease-in-out;
    transition: background 1s ease-in-out;
  }
  .background-video-slider .video-slide .slide-background-overlay, 
  .background-video-slider .bg-image-slide .slide-background-overlay {
    background: #111111;
    background: var(--slide-overlay-background-color, #111111);
  }
  .background-video-slider .video-slide.active .slide-background-overlay, 
  .background-video-slider .bg-image-slide.active .slide-background-overlay {
    background: linear-gradient(to top, #111111 1%, transparent 40%);
    background: linear-gradient(to top, var(--slide-overlay-background-color, #111111) 1%, transparent 40%);
  }
  .background-video-slider .video-slide.slow-load.active .slide-background-overlay {
    background: #111111;
    background: var(--slide-overlay-background-color, #111111);
  }
  .background-video-slider[data-brand="cjdr"] .video-slide.active .slide-background-overlay, 
  .background-video-slider[data-brand="cjdr"] .bg-image-slide.active .slide-background-overlay {
    background: linear-gradient(241deg, rgba(0, 0, 0, 0.00) 47.91%, #000 100%);
  }
  .background-video-slider .slide-content-layer {
    color: #ffffff;
  }
  .background-video-slider .slide-content-layer {
    bottom: 10%;
    left: 0;
    width: 100%;
    padding: 0 0 70px 33px;
  }
  .background-video-slider .slide-text-content {
    font-size: 15px;
  }
  .background-video-slider .sokal-component-subheading {
    font-size: 1.25em;
  }
  .background-video-slider .sokal-component-heading {
    font-size: 3.3em;
    font-weight: bold;
    margin-top: 15px;
    margin-bottom: 15px;
  }
  .background-video-slider .sokal-component-copy,
  .background-video-slider .vehicles-in-stock {
    font-size: 1.25em;
    margin-bottom: 2px;
  }
  .background-video-slider .vehicles-in-stock {
    align-items: center;
    text-decoration: none;
    cursor: pointer;
    color: #ffffff;
    transition: transform 0.35s cubic-bezier(0.25, 1, 0.5, 1);
    will-change: transform;
    transform: translateX(0);
    padding-top: 10px;
  }
  .background-video-slider .vehicles-in-stock:hover {
    transform: translateX(6px);
  }
  .background-video-slider .slide-buttons {
    margin-top: 20px;
  }
  .background-video-slider .sokal-btn {
    font-size: 1rem;
    font-weight: normal;
    line-height: calc(0.875rem + 2px);
    letter-spacing: 1px;
    text-align: center;
    text-decoration: none;
    min-height: 48px;
    padding: 16px 40px;
    border: 2px solid #000000;
    display: inline-block;
    position: relative;
    z-index: 0;
    box-sizing: border-box;
    transition: color ease-in-out .15s;
    margin-top: 10px;
    width: fit-content;
    background: transparent;
    border-radius: var(--brand-br);
  }
  .background-video-slider .sokal-btn::after {
    content: "";
    display: block;
    width: 0px;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: -1;
    box-sizing: border-box;
    transition: width .1s ease-in-out;
  }
  .background-video-slider .sokal-btn:hover::after, 
  .background-video-slider .sokal-btn:focus::after {
    width: 100%;
    left: 0;
    transition: width ease-in-out .2s;
  }
  .background-video-slider .sokal-btn.dark-theme {
    border-color: #ffffff;
  }
  /* Primary Button */
  .background-video-slider .sokal-btn-primary.dark-theme {
    --sokal-btn-bg: #ffffff;
    --sokal-btn-color: #000000;
  }
  .background-video-slider .sokal-btn-primary {
    color: var(--sokal-btn-color);
  }
  .background-video-slider .sokal-btn-primary::after {
    background: var(--sokal-btn-color);
  }
  .background-video-slider .sokal-btn-primary:hover, 
  .background-video-slider .sokal-btn-primary:focus {
    color: var(--sokal-btn-bg);
  }
  .background-video-slider .sokal-btn-primary.dark-theme::after {
    width: 100%;
    background: #ffffff;
    background: var(--sokal-btn-background, #ffffff);
    left: unset;
    right: 0;
  }
  .background-video-slider .sokal-btn-primary.dark-theme:hover::after, 
  .background-video-slider .sokal-btn-primary.dark-theme:focus::after {
    width: 0px;
  }
  /* Secondary Button */
  .background-video-slider .sokal-btn-secondary.dark-theme {
    --sokal-btn-bg: #000000;
    --sokal-btn-color: #ffffff;
  }
  .background-video-slider .sokal-btn-secondary {
    background-color: transparent;
    color: var(--sokal-btn-color);
  }
  .background-video-slider .sokal-btn-secondary::after {
    background: var(--sokal-btn-color);
  }
  .background-video-slider .sokal-btn-secondary:hover, 
  .background-video-slider .sokal-btn-secondary:focus {
    color: var(--sokal-btn-bg);
  }

  /* INFINITI STYLING */
  #backgroundVideoSliderVersionTwo[data-brand="Infiniti"] .sokal-component-heading,
  #backgroundVideoSliderVersionTwo[data-brand="Infiniti"] .sokal-component-subheading {
    font-weight: lighter;
    font-family: Infiniti-Light, 'Infiniti-Light', Arial, sans-serif;
  }
  #backgroundVideoSliderVersionTwo[data-brand="Infiniti"] .sokal-btn {
    overflow: hidden;
    border: 3px solid var(--primary-light, #ffffff); 
  }
  #backgroundVideoSliderVersionTwo[data-brand="Infiniti"] .sokal-btn::after {
    display: none;
  }
  #backgroundVideoSliderVersionTwo[data-brand="Infiniti"] .sokal-btn-primary {
    background-color: var(--primary-light, #ffffff);
    color: var(--primary-color, #020B24);
  }
  #backgroundVideoSliderVersionTwo[data-brand="Infiniti"] .sokal-btn-primary:hover,
  #backgroundVideoSliderVersionTwo[data-brand="Infiniti"] .sokal-btn-primary:focus {
    background-color: transparent;
    color: var(--primary-light, #ffffff);
  }
  #backgroundVideoSliderVersionTwo[data-brand="Infiniti"] .sokal-btn-secondary {
    color: var(--primary-light, #ffffff);
    background-color: transparent;
  }
  #backgroundVideoSliderVersionTwo[data-brand="Infiniti"] .sokal-btn-secondary:hover,
  #backgroundVideoSliderVersionTwo[data-brand="Infiniti"] .sokal-btn-secondary:focus {
    color: var(--primary-color, #020B24);
    background-color: var(--primary-light, #ffffff);
  }
  #backgroundVideoSliderVersionTwo[data-brand="Infiniti"] .sokal-btn-primary,
  #backgroundVideoSliderVersionTwo[data-brand="Infiniti"] .sokal-btn-secondary {
    border-radius: 50px;
  }
  #backgroundVideoSliderVersionTwo[data-brand="Infiniti"] .component-slide-content {
    margin-top: -30px;
  }

  @media (min-width: 768px) {
    .background-video-slider .slide-content-layer {
      max-width: calc(100% - 20vw);
    }
    .background-video-slider button.prev-slide, 
    .background-video-slider button.next-slide {
      left: unset;
      transform: none;
      bottom: 60px;
    }
    .background-video-slider button.prev-slide {
      right: calc(4% + 60px);
    }
    .background-video-slider button.next-slide {
      right: 4%;
    }
    .background-video-slider button.navigate-slides svg {
      border: solid 2px #ffffff;
      border: solid 2px var(--carousel-controls-color, #ffffff);
      border-radius: 100%;
      -moz-transition: all 0.3s ease;
      -webkit-transition: all 0.3s ease;
      transition: all 0.3s ease;
    }
    .background-video-slider .carousel-indicators {
      bottom: 10px;
    }
  }

  @media (max-width: 767px) {
    .background-video-slider .component-slide-content {
      min-height: 500px;
      height: 77vh;
    }
    .background-video-slider .slide-content-layer {
      padding: 0 30px 100px 30px;
    }
    .background-video-slider .video-slide.active .slide-background-overlay, 
    .background-video-slider .bg-image-slide.active .slide-background-overlay {
      background: linear-gradient(to top, #111111 1%, transparent 100%);
      background: linear-gradient(to top, var(--slide-overlay-background-color, #111111) 1%, transparent 100%);
    }
    .background-video-slider .carousel-indicators {
      bottom: 2.5%;
    }
  }

  @media (min-width: 576px) {
    .background-video-slider .slide-buttons[data-first-btn-present="true"] .additional-btn {
      margin-left: 15px;
    }
  }

  @media (max-width: 575px) {
    .background-video-slider .sokal-btn {
      width: 100%;
    }
    .background-video-slider .sokal-component-heading {
      font-size: 2.2em;
    }
  }

  @media (max-width: 375px) {
    .background-video-slider .sokal-component-heading {
      font-size: 2.2em;
    }
  }
</style>